import api from 'services/api';

export async function resendConfirmationEmail(email: string) {
  const response = await api.post('api/auth/confirmation', {
    user: { email },
  });

  return response;
}
